<script>

export default {
  inject: ['$axios'],
  name: 'PassResetView',
  props: {},
  data() {
    return {
      resetProcessing: false,
      showPasswordForm: false,
      passwordFormErrorMessage: '',
      passwordResetSuccess: false,
      passwordResetMsg: '',
      emailRegex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
      passwordRegex: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/,
      passwordToken: '',
      resetEmail: {
        value: "",
        error: false
      },
      resetPassword: {
        value: "",
        error: false
      },
      confirmPassword: {
        value: "",
        error: false
      },
    }
  },
  methods: {
    validateResetEmail() {
      this.resetEmail.error = this.resetEmail.value === "";
    },
    validateResetPassword() {
      this.resetPassword.error = this.resetPassword.value === "";
    },
    onPasswordSubmit() {
      let vm = this;
      try {
        vm.$axios
            .post('/auth/user/passwordReminder', {
              email: vm.passReminderEmail.value
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.$emit('passwordResetEmission', {status: true, reminderData: response.data.msg});
                  break;
                case 'false':
                  vm.$emit('passwordResetEmission', {status: false, reason: response.data.msg});
                  break;
              }
            })
      } catch (error) {
        console.error(error);
      }
    },
    checkTokenValidity() {
      let vm = this;
      try {
        vm.$axios
            .post('/auth/user/checkPasswordToken', {
              passwordToken: vm.$route.params.passToken
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.showPasswordForm = true;
                  vm.passwordFormErrorMessage = '';
                  break;
                case 'false':
                  vm.showPasswordForm = false;
                  vm.passwordFormErrorMessage = response.data.msg;
                  break;
              }
            });
      } catch (error) {
        console.error(error);
      }
    },
    onPasswordResetSubmit() {
      let vm = this;
      try {
        if (vm.resetProcessing) {
          console.error('Reset in progress');
        } else {
          if (vm.resetValid) {
            vm.resetProcessing = true;
            vm.$axios
                .post('/auth/user/passwordReset', {
                  email: vm.resetEmail.value,
                  password: vm.resetPassword.value,
                  passwordToken: vm.$route.params.passToken
                }, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.passwordResetSuccess = true;
                      vm.showPasswordForm = false;
                      vm.passwordResetMsg = response.data.msg;
                      break;
                    case 'false':
                      vm.resetProcessing = false;
                      vm.passwordResetSuccess = false;
                      vm.passwordResetMsg = response.data.msg;
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
        vm.resetProcessing = false;
      }
    }
  },
  computed: {
    resetEmailValid() {
      return this.emailRegex.test(this.resetEmail.value);
    },
    resetPasswordValid() {
      return (this.resetPassword.value === this.confirmPassword.value) && (this.resetPassword.value.length > 0);
    },
    resetValid() {
      return (
          this.resetEmailValid &&
          this.resetPasswordValid
      );
    }
  },
  mounted() {
    let vm = this;
    vm.checkTokenValidity();
  }
}
</script>

<template>
  <div id="page-style">
    <div class="app-version top-version-text">&nbsp;</div>
    <div class="loginBox">
      <div class="inner">

        <div class="top">
          <div class="title">
            <span class="AMH-darkGray-text">S</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">A</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">F</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">E</span>
            <span class="AMH-darkGray-text">.</span>
          </div>
          <img alt="Missing Page" src="../assets/icon.png" class="logo">
        </div>

        <div v-if="showPasswordForm">
          <div class="signIn">
            <div class="title">Password Reset</div>
            <div class="subtitle form-subtitle">
              Remembered your password?
              <span class="subtitle-action"> <a href="/"> Sign in</a> </span>
            </div>
          </div>
        </div>

        <div>

          <form v-on:submit.prevent="onPasswordResetSubmit" v-if="showPasswordForm">
            <div class="form">
              <input
                  type="text"
                  class="w100"
                  placeholder="Email"
                  @blur="validateResetEmail"
                  @keydown="validateResetEmail"
                  v-model="resetEmail.value"
              />
              <input
                  type="password"
                  class="w100"
                  placeholder="Password"
                  v-model="resetPassword.value"
                  @blur="validateResetPassword"
                  @keydown="validateResetPassword"
              />
              <input
                  type="password"
                  class="w100"
                  placeholder="Confirm Password"
                  v-model="confirmPassword.value"
              />

              <input
                  type="submit"
                  value="Reset Password"
                  class="action"
                  :class="{ 'action-disabled': !resetValid || resetProcessing }"
              />
            </div>

            <div class="subtitle form-subtitle reset-message-resp" v-if="passwordResetMsg.length>0">
              {{ passwordResetMsg }}
            </div>

          </form>
          <div v-else>
            <div class="title" v-if="passwordFormErrorMessage.length>0">{{ passwordFormErrorMessage }}</div>
            <div class="title" v-if="passwordResetMsg.length>0">{{ passwordResetMsg }}</div>
            <div class="subtitle form-subtitle">
              <span class="subtitle-action"> <a href="/"> Take me home</a> </span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="app-version bottom-version-text">Surgical Access For Everyone</div>
  </div>
</template>

<style scoped>

.error-title {
  margin: 0 !important;
  font-weight: normal !important;
}

.reset-message-resp {
  margin-top: 20px;
}

</style>